/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs */

const en_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niche brief`)
};

const ar_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موجز التخصص`)
};

const bn_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিশ ব্রিফ`)
};

const de_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nischen-Briefing`)
};

const es_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de nicho`)
};

const fr_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief de niche`)
};

const pt_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo de nicho`)
};

const zh_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛道简报`)
};

const tr_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niş brifi`)
};

const ru_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бриф ниши`)
};

const pl_svc_ai_image_pod_automation_scope_output5 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief niszy`)
};

/**
* | output |
* | --- |
* | "Niche brief" |
*
* @param {Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_scope_output5 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_scope_output5(inputs)
	return en_svc_ai_image_pod_automation_scope_output5(inputs)
});
export { svc_ai_image_pod_automation_scope_output5 as "svc_ai-image-pod-automation_SCOPE_output" }